import { render, staticRenderFns } from "./MassEmailMobileCard.vue?vue&type=template&id=97b03eec&scoped=true"
import script from "./MassEmailMobileCard.vue?vue&type=script&lang=js"
export * from "./MassEmailMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b03eec",
  null
  
)

export default component.exports